import axios from 'axios';

// Usa configurazione runtime se disponibile (per domini personalizzati)
// altrimenti usa la variabile d'ambiente
const getBackendUrl = () => {
  if (window.RUNTIME_CONFIG && typeof window.RUNTIME_CONFIG.getBackendUrl === 'function') {
    return window.RUNTIME_CONFIG.getBackendUrl();
  }
  return process.env.REACT_APP_BACKEND_URL || window.location.origin;
};

const BACKEND_URL = getBackendUrl();
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authApi = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

// Admin API
export const adminApi = {
  getUsers: () => api.get('/admin/users'),
  getPendingUsers: () => api.get('/admin/users/pending'),
  approveUser: (userId, approvato) => api.put(`/admin/users/${userId}/approve`, { approvato }),
  deleteUser: (userId) => api.delete(`/admin/users/${userId}`),
};

// Fornitori API
export const fornitoriApi = {
  getAll: (search = '') => api.get('/fornitori', { params: { search } }),
  getOne: (id) => api.get(`/fornitori/${id}`),
  create: (data) => api.post('/fornitori', data),
  update: (id, data) => api.put(`/fornitori/${id}`, data),
  delete: (id) => api.delete(`/fornitori/${id}`),
};

// Clienti API
export const clientiApi = {
  getAll: (search = '') => api.get('/clienti', { params: { search } }),
  getOne: (id) => api.get(`/clienti/${id}`),
  create: (data) => api.post('/clienti', data),
  update: (id, data) => api.put(`/clienti/${id}`, data),
  delete: (id) => api.delete(`/clienti/${id}`),
};

// Campagne API
export const campagneApi = {
  getAll: (params = {}) => api.get('/campagne', { params }),
  getOne: (id) => api.get(`/campagne/${id}`),
  create: (data) => api.post('/campagne', data),
  update: (id, data) => api.put(`/campagne/${id}`, data),
  delete: (id) => api.delete(`/campagne/${id}`),
  aggiungiRiga: (campagnaId, data) => api.post(`/campagne/${campagnaId}/righe`, data),
  rimuoviRiga: (campagnaId, rigaId) => api.delete(`/campagne/${campagnaId}/righe/${rigaId}`),
};

// Dashboard API
export const dashboardApi = {
  getStats: () => api.get('/dashboard/stats'),
};

// Export API
export const exportApi = {
  downloadFornitoriCsv: async () => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE}/export/fornitori/csv`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'fornitori_export.csv';
    a.click();
  },
  downloadCampagneCsv: async () => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE}/export/campagne/csv`, { headers: { Authorization: `Bearer ${token}` } });
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'campagne_export.csv';
    a.click();
  },
};

export default api;
